import c from "../common";

export default {
  //header
  Back: c.Back.en,
  ChangeData: "Modify " + c.vendor.en.uppercase + " Detail",
  ReasonModify: "Reason to Modify or Detail of Modification",

  //
  Approved: c.approved.en,
  NeedEdit: "Need Resubmit",

  //Card Showing status
  StatusTitle: "Approval Progress",
  Number: "Request ID",
  AppliedOn: "Applied On",
  LastModify: "Last Modify",
  ApprovedOn: "Approved On",
  Progress: "Progress",

  //Status
  Processing: "Processing",
  Approved: "Approved",
  NeedModify2: "Need Resubmit",
  Reject: "Reject",

  //BR
  RelatedDoc: "Related Document",
  businessNumber: "Business Number",
  BR: "Business Registration Certificate",
  Download: c.download.en.uppercase,

  //Detail Card - processing merchant
  VendorData: c.vendor.en.uppercase + " Data",
  Address: "Address of " + c.vendor.en.uppercase,
  ShowAllAdd: "Show All Address",
  OpeningHour: "Opening Hour",
  intro: c.intro.en,
  Vendor: "Requested By",

  success: "success",
  updateInfo: "Update Information",
  addTotalQty: "Add Total Qty",
  Cancelled: c.Cancelled.en,


  description_1: "Reject Reason (if any)",
  description_2: "Confirm Reject",
  description_3: "Provide reject reason if any, you can leave it empty",

  description_4: c.vendor.en.lowercase + " not approved",
  description_5: c.vendor.en.lowercase + " already joined",
  description_6: "Error: ",
  description_7: "partner not exist",
  description_8: "not belong",
  description_9: "belong to ",
  description_10: "remove",
  description_11: "add",
  description_12: "belong to our company",
  description_13: "does not belong to our company",
  description_14: c.vendor.en.lowercase + " ID",
  description_15: "partner",
  description_16: "add",
  description_17: "belong to our company",
  description_18: "none",
};
